import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { CollectionCreatePage } from '@/features/collections';

export const Route = createFileRoute('/_authed/_active/s/$storeId/collections/new')({
  staticData: { crumb: 'collections:new', tours: ['collections.new'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'collections.write');
  },
  component: CollectionCreatePage,
});
